module.exports = __webpack_public_path__ + "img/Data-pipeline-2.87bd5dad.png";